import {
  getRemoteConfig,
  fetchAndActivate as fbFetchAndActivate,
  getBoolean as fbGetBoolean,
  getString as fbGetString,
  getNumber as fbGetNumber,
  RemoteConfig,
} from 'firebase/remote-config';
import type { IRemoteConfigService } from '@breath-lab/services';
import type { BreathworkNameDisplay } from '@breath-lab/types';
import { firebaseApp } from '../firebase/firebaseConfig';

export class WebRemoteConfigService implements IRemoteConfigService {
  private rc: RemoteConfig;

  constructor() {
    this.rc = getRemoteConfig(firebaseApp);
    this.rc.settings.minimumFetchIntervalMillis = import.meta.env.DEV ? 0 : 3600000;
    this.rc.defaultConfig = {
      freeBreathworksIds: '[]',
      freeJourneysIds: '[]',
      navbarLayoutEnabled: true,
      defaultBreathworkNameDisplay: 'sanskrit',
    };
  }

  async fetchAndActivate(): Promise<void> {
    await fbFetchAndActivate(this.rc);
  }

  getBoolean(key: string, defaultValue = false): boolean {
    const val = fbGetBoolean(this.rc, key);
    return val === undefined ? defaultValue : val;
  }

  getString(key: string, defaultValue = ''): string {
    const val = fbGetString(this.rc, key);
    return val === '' ? defaultValue : val;
  }

  getNumber(key: string, defaultValue = 0): number {
    const val = fbGetNumber(this.rc, key);
    return Number.isNaN(val) ? defaultValue : val;
  }

  async fetchCatalogGates(): Promise<{
    freeBreathworksIds: string[];
    freeJourneysIds: string[];
    paywallEnabled: boolean;
  }> {
    await this.fetchAndActivate();
    const parseArray = (raw: string): string[] => {
      try {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? (parsed as string[]) : [];
      } catch {
        return [];
      }
    };
    return {
      freeBreathworksIds: parseArray(this.getString('freeBreathworksIds')),
      freeJourneysIds: parseArray(this.getString('freeJourneysIds')),
      paywallEnabled: true,
    };
  }

  getDefaultBreathworkNameDisplay(): BreathworkNameDisplay {
    const val = this.getString('defaultBreathworkNameDisplay');
    return val === 'english' ? 'english' : 'sanskrit';
  }
}
